import React from "react";
import ProductForm from "./ProductFrom";


// Replaces the old EditProduct.jsx (which had the unbalanced </div> at line 821).
// The product id comes from the route (:id) inside ProductForm.
const AdminEditProduct = () => <ProductForm mode="edit" />;

export default AdminEditProduct;